exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-59034fae]{display:inline-block;vertical-align:baseline;margin-bottom:-2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/home/vintagp/www/toyota_dreamcar/front/assets","/static":"/home/vintagp/www/toyota_dreamcar/front/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59034fae","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/_UI/BaseShape.vue
// module id = Lei0
// module chunks = 13